/**
 * Calculates the complete flex shorthand value for items in a flex container
 * @param itemsPerRow Number of items you want to fit in one row
 * @param gap Gap size in pixels between items
 * @returns CSS flex shorthand value as a string (flex-grow flex-shrink flex-basis)
 */
export function calculateFlex(itemsPerRow: number, gap = 16): string {
  // Total gap space = gap size × (number of items - 1)
  const totalGapSpace = `${gap * (itemsPerRow - 1)}px`;

  return `0 0 calc((100% - ${totalGapSpace}) / ${itemsPerRow})`;
}
